module.exports = __webpack_public_path__ + "static/img/68-3.b698521.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/68-3.jpg
// module id = Hcn2
// module chunks = 0